export const siteLogo = {
    logo: "assets/images/ts-logo.png",  // Add your site logo here
    alt: "TS v-development Ltd."  // Add your site name here
};
export const socialLink = {
    facebook: "https://www.facebook.com",  
    twitter: "https://www.twitter.com",
    linkedin: "https://www.linkedin.com",
    youtube: "https://www.youtube.com",
    whatsapp: "https://wa.me/85257225345",
    instagram: "https://www.instagram.com/ili.cheng/"
};
export const mailchimpLink = {
    link: (process.env.REACT_APP_MAILCHAIMP) // Add your mailchimp list link here
    
};
export const contactFormAction = {
    link: (process.env.REACT_APP_CONTACTFORM)  // Add for link here from https://formspree.io
}
